import React, { FunctionComponent } from "react";
import styles from "./Recipe.module.scss";
import RecipeBlockProps from "./RecipeProps.interface";

import BackgroundMedia from "components/BackgroundMedia/BackgroundMedia";
import combineClasses from "helpers/combine-classes";
import ContentPageBlock from "pages/ContentPage/ContentPage.block"; // TODO: Replace with Recipe Block List instead
import getWrapperClasses from "blocks/helpers/getWrapperClasses";
import Schema from "./components/Schema/Schema";
import useWrapperStyles from "blocks/hooks/useWrapperStyles";
import Dictionary from "components/Dictionary/Dictionary";
import useSplitBackground from "blocks/hooks/useSplitBackground";
import useAnchor from "blocks/hooks/useAnchor";

const Recipe: FunctionComponent<RecipeBlockProps> = (props): JSX.Element => {
    const wrapperClasses = getWrapperClasses(props.settings);
    const wrapperStyles = useWrapperStyles(props.settings);

    const identifier = useAnchor(props.settings.anchorMenuLabel);
    const { splitClasses, splitStyles } = useSplitBackground(props);

    return (
        <section className={combineClasses(styles.wrapper, ...wrapperClasses)} style={{ ...wrapperStyles, ...splitStyles }} id={identifier}>
            <div className={combineClasses(styles.container, ...splitClasses)}>
                <article className={styles.content}>
                    {props.content.blocks?.map((blockContent, index) => {
                        return (
                            <ContentPageBlock key={index} {...blockContent} />
                        );
                    })}
                </article>
                <aside className={styles.aside}>
                    <section className={styles.box}>
                        <h3><Dictionary name="RECIPE.INGREDIENTS" /></h3>

                        <ul className={styles.ingredients}>
                            {props.content.ingredients?.map((ingredient: any, key: number) => {
                                return (
                                    <li key={`ing_${key}`}>{ingredient}</li>
                                );
                            })}
                        </ul>
                    </section>

                    <section className={styles.box}>
                        <h3><Dictionary name="RECIPE.STEPS" /></h3>

                        <ol className={styles.steps}>
                            {props.content.steps?.map((step: any, key: number) => {
                                return (
                                    <li key={`ste_${key}`}>{step}</li>
                                );
                            })}
                        </ol>
                    </section>
                </aside>
            </div>

            {props.content.ingredients || props.content.steps ? (
                <Schema {...props.content} />
            ) : null}

            {props.settings.backgroundMedia?.[0] && props.settings.backgroundMedia.length > 0 ? (
                <BackgroundMedia key={props.contentUdi} {...props.settings.backgroundMedia[0]} />
            ) : null}
        </section>
    );
};

export default Recipe;